module.exports = __webpack_public_path__ + "assets/media/drift-logo-with-name.cc8afc22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drift-logo-with-name.svg
// module id = 113
// module chunks = 0